import { __assign } from "tslib";
import s from './solution-overview.scss';
import { config } from '../../../../config';
import { composer } from '../../../../component-decorators/composer';
import { biLogger } from '../../../../bi';
import { Card, Tag, Text, TextButton, InfoIcon, Box, } from 'wix-style-react';
import Add from 'wix-ui-icons-common/Add';
import { previewModeContext } from '../../preview-elements';
import { AppMarketLink, Path } from '../../../..';
import { useConfigContext } from '../../../../config-context';
import React from 'react';
import { allCountriesCodes, getCountryISO2, } from '../../../standalone-header/header-user-details/header-desktop-user-details/header-desktop-languages-popover/header-desktop-languages-popover-content/languages';
import { ModalNames } from '../../../modals/modals';
import { isWixApp, wixChatBotLink } from '../../../../common/utils';
import { OtherCountries } from "./other-countries/other-countries-options";
export var dtoToTagsBoxProps = function (solutionDto) {
    var tags = filterTags(solutionDto.baseInfo.Tags);
    var appId = solutionDto.baseInfo.id;
    var isRequiredWixPremium = solutionDto.baseInfo &&
        solutionDto.baseInfo.pricing &&
        solutionDto.baseInfo.pricing.isRequiredWixPremium;
    var includeCountries = solutionDto.includeCountries;
    var excludeCountries = solutionDto.excludeCountries;
    var excludeLanguages = solutionDto.excludeLanguages;
    var allowLanguageCustomization = solutionDto.allowLanguageCustomization;
    var requiredApps = solutionDto.requiredApps || [];
    var appName = solutionDto.baseInfo.name;
    var contactMail = solutionDto.supportEmails && solutionDto.supportEmails.join(';');
    var includeLanguages = solutionDto.includeLanguages;
    var baseInfo = solutionDto.baseInfo;
    var assetsMap = solutionDto.assetsMap;
    var company = solutionDto.company;
    var webSolutionData = solutionDto.webSolutionData;
    return {
        tags: tags,
        appId: appId,
        isRequiredWixPremium: isRequiredWixPremium,
        includeCountries: includeCountries,
        excludeCountries: excludeCountries,
        excludeLanguages: excludeLanguages,
        allowLanguageCustomization: allowLanguageCustomization,
        requiredApps: requiredApps,
        appName: appName,
        contactMail: contactMail,
        includeLanguages: includeLanguages,
        baseInfo: baseInfo,
        assetsMap: assetsMap,
        company: company,
        webSolutionData: webSolutionData,
    };
};
export var removeDuplicateNames = function (tags) {
    if (tags && tags.length) {
        return tags.filter(function (obj, pos, arr) {
            return arr.map(function (mapObj) { return mapObj.name; }).indexOf(obj.name) === pos;
        });
    }
    return [];
};
var filterCollections = function (tags) {
    if (tags && tags.length) {
        return tags.filter(function (tag) { return tag.type === 'COLLECTION' && !tag.isHidden; });
    }
    return [];
};
var filterTags = function (tags) {
    if (tags && tags.length) {
        return removeDuplicateNames(filterCollections(tags));
    }
    return [];
};
var tagNavigate = function (tag) {
    config.goto({
        path: Path.COLLECTION,
        slug: tag === null || tag === void 0 ? void 0 : tag.slug,
        referral: 'app_tag',
    });
};
export var FeaturedIn = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var tags = _a.tags, t = _a.t, marketplaceStore = _a.marketplaceStore;
    // tslint:disable-next-line: react-hooks-nesting
    var isPreview = previewModeContext().isPreview;
    return tags && tags.length > 0 ? (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-testid": "tags-box" }),
        React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle, style: { marginBottom: '6px' } }, t('solution.page.tagsBoxTitle')),
        React.createElement("div", { className: s.tagBoxSection }, tags.map(function (tag) { return (
        // tslint:disable-next-line:jsx-key
        React.createElement(AppMarketLink, { to: Path.COLLECTION + "/" + tag.slug, onClick: function () {
                biLogger.categoryClick({
                    category: tag.slug.replace(/-/g, '_'),
                    msid: marketplaceStore.metaSiteId,
                    origin: 'more_apps_like_this',
                    tag_name: tag.slug.replace(/-/g, '_'),
                    tag_type: 'collection',
                });
                tagNavigate(tag);
            } },
            React.createElement(Tag, { dataHook: "tag-hook-" + tag.slug, key: tag.slug, id: tag.slug, onClick: function (x) { }, removable: false, theme: "standard", className: s.solutionTag, size: 'small' }, tag.name))); })))) : isPreview ? (React.createElement("div", { "data-testid": "tags-box" },
        React.createElement("div", { className: s.tagBoxSection },
            React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle, style: { marginBottom: '6px' } }, t('solution.page.tagsBoxTitle')),
            React.createElement(Tag, { key: 'newest', id: 'newest', onClick: function (x) { }, removable: false, theme: "standard", className: s.solutionTag }, t('solution.page.tagsBoxPreviewTag'))))) : null;
});
export var SiteRequirements = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, isRequiredWixPremium = _a.isRequiredWixPremium, appId = _a.appId, requiredApps = _a.requiredApps;
    // tslint:disable-next-line: react-hooks-nesting
    var isPreview = previewModeContext().isPreview;
    return (requiredApps && requiredApps.length) || isRequiredWixPremium ? (React.createElement("div", { className: s.tagBoxSection },
        React.createElement("div", { className: s.availabilityTitle },
            React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle }, t('solution.page.tagsBoxSiteReq')),
            React.createElement(SiteReqTooltip, null)),
        requiredApps.length ? (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { display: 'flex', alignItems: 'baseline' } },
                React.createElement("span", { style: { paddingRight: '6px' } }, " - "),
                React.createElement("div", null, requiredApps.map(function (app, index) {
                    return (React.createElement("div", { style: { marginTop: '6px' } },
                        React.createElement(AppMarketLink, { to: "" + app.slug, onClick: function () {
                                biLogger.appMarketSiteRequirementsTagClick({
                                    app_id: appId,
                                    required_app_id: app.id,
                                });
                                config.goto({
                                    path: Path.WEB_SOLUTION,
                                    slug: app.slug,
                                });
                            } },
                            React.createElement(TextButton, { size: 'small', as: "a", key: app.name }, app.name)),
                        requiredApps[index + 1] ? (React.createElement("span", null, " / \u00A0")) : null));
                }))))) : null,
        isRequiredWixPremium && (React.createElement("div", null,
            React.createElement("div", { style: { marginTop: '6px' } },
                React.createElement("span", null, " - "),
                React.createElement(Text, { size: "small", weight: 'thin' }, t('solution.page.tagsBoxSiteReqPremium'))),
            React.createElement("div", { style: { marginTop: '6px' } },
                React.createElement("span", null, " - "),
                React.createElement(Text, { size: "small", weight: 'thin' }, t('solution.page.tagsBoxSiteReqDomain'))))))) : (React.createElement(React.Fragment, null, isPreview && requiredApps.length === 0 ? (React.createElement("div", { className: s.tagBoxSection },
        React.createElement("div", { className: s.availabilityTitle },
            React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle }, t('solution.page.tagsBoxSiteReq')),
            React.createElement(SiteReqTooltip, null)),
        React.createElement(Text, { size: "small", weight: 'thin' }, t('solution.page.tagsBoxSiteReqPreview1')),
        React.createElement("br", null),
        React.createElement(TextButton, { prefixIcon: React.createElement(Add, null), as: "a", href: "https://dev.wix.com/dc3/my-apps/" + appId + "/market/info/installation", target: "_blank" }, t('solution.page.tagsBoxSiteReqPreview2')))) : null));
});
export var AppLanguages = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, includeLanguages = _a.includeLanguages, allowLanguageCustomization = _a.allowLanguageCustomization, appId = _a.appId;
    // tslint:disable-next-line: react-hooks-nesting
    var langs = includeLanguages ? includeLanguages : [];
    var translatedLangs = langs
        .map(function (lang) { return t("marketplace.language." + lang.toUpperCase()); })
        .sort();
    var isPreview = previewModeContext().isPreview;
    return translatedLangs && translatedLangs.length ? (React.createElement("div", { className: s.tagBoxSection },
        React.createElement("div", { className: s.availabilityTitle },
            React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle }, t('solution.page.tagsBoxSupportedLangTitle')),
            React.createElement(LanguagesTooltip, null)),
        React.createElement("div", { className: s.appLanguages }, translatedLangs.map(function (lang, index) { return (
        // tslint:disable-next-line:jsx-key
        React.createElement("span", { style: { display: 'inline-block' } },
            React.createElement(Text, { size: "small", weight: 'thin' },
                lang,
                translatedLangs[index + 1] && (React.createElement("span", { style: { display: 'inline-block' } }, ",\u00A0"))))); })),
        allowLanguageCustomization && (React.createElement("div", { className: s.customizeLang },
            React.createElement(Text, { size: "small", weight: 'thin', secondary: true }, t('solution.page.tagsBoxSupportedLangCustomize')))))) : isPreview ? (React.createElement("div", { className: s.tagBoxSection },
        React.createElement("div", { className: s.availabilityTitle },
            React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle }, t('solution.page.tagsBoxSupportedLangTitle')),
            React.createElement(LanguagesTooltip, null)),
        React.createElement(TextButton, { as: "a", href: "https://dev.wix.com/dc3/my-apps/" + appId + "/market/info/installation", target: "_blank" },
            React.createElement("span", null, "\u00A0"),
            t('solution.page.tagsBoxSupportedLangPreview')))) : null;
});
export var AvailabilityTooltip = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement(Box, { align: "center" },
        React.createElement(InfoIcon, { size: 'small', content: t('solution.page.tagsBoxAvailabilityTooltip') })));
});
export var LanguagesTooltip = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement(Box, { align: "center" },
        React.createElement(InfoIcon, { size: 'small', content: t('solution.page.tagsBoxSupportedLangTooltip') })));
});
export var SiteReqTooltip = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement(Box, { align: "center" },
        React.createElement(InfoIcon, { size: 'small', content: t('solution.page.tagsBoxSiteReqTooltip') })));
});
export var AppAvailability = composer()
    .withTranslation()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (props) {
    var _a;
    var t = props.t, includeCountries = props.includeCountries, excludeCountries = props.excludeCountries, experiments = props.experiments, marketplaceStore = props.marketplaceStore, contactMail = props.contactMail, appId = props.appId, appName = props.appName;
    var appFromInstalled = marketplaceStore.installedApps && ((_a = marketplaceStore.installedApps) === null || _a === void 0 ? void 0 : _a.find(function (installedApp) { return installedApp.webSolutionBase.id === appId; }));
    // tslint:disable-next-line: react-hooks-nesting
    var _b = useConfigContext(), shouldUseSupportModal = _b.shouldUseSupportModal, isMobile = _b.isMobile;
    var allCountries = allCountriesCodes;
    var isWorldWide = (includeCountries && includeCountries.length) === 0 &&
        (excludeCountries && excludeCountries.length) === 0;
    var allIncludedCountries = includeCountries && includeCountries.length
        ? includeCountries
        : allCountries.filter(function (country) { return excludeCountries && !excludeCountries.includes(country); });
    // tslint:disable-next-line: react-hooks-nesting
    var countryCode = useConfigContext().countryCode;
    var countryCodeISO2 = getCountryISO2(countryCode);
    var isPreview = previewModeContext().isPreview;
    var appAvailabeInUserGeo = countryCodeISO2 && allIncludedCountries.includes(countryCodeISO2);
    var appNotAvailableInUserGeo = countryCodeISO2 && !excludeCountries.includes(countryCodeISO2);
    var translatedIncludeCountries = allIncludedCountries.map(function (country) {
        return t("marketplace.country." + country);
    });
    var noUserGeo = !countryCodeISO2;
    // tslint:disable-next-line: react-hooks-nesting
    var madeByWix = props.company &&
        props.company.companyBase &&
        isWixApp(props.company.companyBase.id);
    var contactSupportOnClick = function () {
        if (madeByWix) {
            window.open(wixChatBotLink);
        }
        else if ((experiments.enabled('specs.marketplace.manage-apps.support-modal') ||
            experiments.enabled("specs.marketplace.support-modal-for-" + appId)) &&
            shouldUseSupportModal &&
            appFromInstalled) {
            marketplaceStore.openModal(ModalNames.SUPPORT_MODAL, {
                // @ts-ignore
                app: appFromInstalled ? appFromInstalled : props,
                closeModal: function () { return marketplaceStore.closeAllModals(); },
                clickSource: 'countriesPopover',
                pageName: 'app_page',
            });
        }
        else if (window) {
            window.location.href = 'mailto:' + contactMail;
        }
    };
    return (React.createElement(React.Fragment, null, isWorldWide ? (React.createElement("div", { className: s.tagBoxSection },
        React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle }, t('solution.page.tagsBoxAvailabilityTitle')),
        React.createElement(Text, { size: "small", weight: 'thin' }, t('solution.page.tagsBoxAvailabilityWorldwide')),
        isPreview ? (React.createElement(TextButton, { as: "a", href: "https://dev.wix.com/dc3/my-apps/" + appId + "/market/info/installation", target: "_blank" },
            React.createElement("span", null, "\u00A0"),
            t('solution.page.tagsBoxAvailabilityPreview'))) : null)) : translatedIncludeCountries.length === 1 ? (React.createElement("div", { className: s.tagBoxSection },
        React.createElement("div", { className: s.availabilityTitle },
            React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle }, t('solution.page.tagsBoxAvailabilityTitle')),
            React.createElement(AvailabilityTooltip, null)),
        React.createElement(Text, { size: "small", weight: 'thin' }, t('solution.page.tagsBoxAvailabilityText6', {
            countryName: translatedIncludeCountries[0],
        })))) : appAvailabeInUserGeo ? (React.createElement("div", { className: s.tagBoxSection },
        React.createElement("div", { className: s.availabilityTitle },
            React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle }, t('solution.page.tagsBoxAvailabilityTitle')),
            React.createElement(AvailabilityTooltip, null)),
        React.createElement(Text, { size: "small", weight: 'thin' }, t('solution.page.tagsBoxAvailabilityText1', {
            countryName: t("marketplace.country." + countryCodeISO2),
        })),
        React.createElement("span", null, "\u00A0"),
        translatedIncludeCountries.length > 1 && (React.createElement(React.Fragment, null,
            React.createElement(Text, { size: "small", weight: 'thin' }, t('solution.page.tagsBoxAvailabilityText2')),
            React.createElement(OtherCountries, { popoverElementTitle: t('solution.page.tagsBoxAvailabilityText3'), isMobile: isMobile, popoverTitle: t('solution.page.tagsBoxAvailabilityPopoverTitle', { appName: appName }), countries: translatedIncludeCountries, madeByWix: madeByWix, contactMail: contactMail, appId: appId, onSupportClick: contactSupportOnClick }))))) : !noUserGeo &&
        (!appAvailabeInUserGeo || appNotAvailableInUserGeo) ? (React.createElement("div", { className: s.tagBoxSection },
        React.createElement("div", { className: s.availabilityTitle },
            React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle }, t('solution.page.tagsBoxAvailabilityTitle')),
            React.createElement(AvailabilityTooltip, null)),
        React.createElement(Text, { size: "small", weight: 'thin' }, t('solution.page.tagsBoxAvailabilityText4', {
            countryName: t("marketplace.country." + countryCodeISO2),
        })),
        translatedIncludeCountries.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement(Text, { size: "small", weight: 'thin' }, t('solution.page.tagsBoxAvailabilityText5', {
                countryName: t("marketplace.country." + countryCodeISO2),
            })),
            React.createElement(OtherCountries, { popoverElementTitle: t('solution.page.tagsBoxAvailabilityText3'), isMobile: isMobile, madeByWix: madeByWix, popoverTitle: t('solution.page.tagsBoxAvailabilityPopoverTitle', { appName: appName }), countries: translatedIncludeCountries, contactMail: contactMail, appId: appId, onSupportClick: contactSupportOnClick }))))) : noUserGeo && translatedIncludeCountries.length > 1 ? (React.createElement("div", { className: s.tagBoxSection },
        React.createElement("div", { className: s.availabilityTitle },
            React.createElement(Text, { size: "small", weight: 'bold', className: s.tagBoxTitle }, t('solution.page.tagsBoxAvailabilityTitle')),
            React.createElement(AvailabilityTooltip, null)),
        React.createElement(Text, { size: "small", weight: 'thin' }, t('solution.page.tagsBoxAvailabilityText8')),
        React.createElement(OtherCountries, { popoverTitle: t('solution.page.tagsBoxAvailabilityPopoverTitle', {
                appName: appName,
            }), popoverElementTitle: t('solution.page.tagsBoxAvailabilityText7'), isMobile: isMobile, countries: translatedIncludeCountries, madeByWix: madeByWix, contactMail: contactMail, appId: appId, onSupportClick: contactSupportOnClick }))) : (React.createElement("span", null))));
});
export var TagsBox = composer()
    .withTranslation()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (props) {
    return (React.createElement(Card, { className: s.tagBoxContainer },
        React.createElement(React.Fragment, null,
            React.createElement(AppAvailability, __assign({}, props)),
            React.createElement(AppLanguages, { includeLanguages: props.includeLanguages, allowLanguageCustomization: props.allowLanguageCustomization, appId: props.appId }),
            React.createElement(SiteRequirements, { isRequiredWixPremium: props.isRequiredWixPremium, appId: props.appId, requiredApps: props.requiredApps })),
        React.createElement(FeaturedIn, { tags: props.tags, appId: props.appId })));
});
//# sourceMappingURL=solution-tag-box.js.map